var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5804 23C9.98236 23 8.48321 22.6955 7.08291 22.0864C5.68258 21.4773 4.45729 20.6549 3.40705 19.6191C2.3568 18.5834 1.5264 17.3624 0.91584 15.9562C0.30528 14.5501 0 13.0499 0 11.4558C0 9.88005 0.30528 8.39647 0.91584 7.00504C1.5264 5.61362 2.3568 4.39681 3.40705 3.35462C4.45729 2.31243 5.68258 1.49278 7.08291 0.895669C8.48321 0.298556 9.98236 0 11.5804 0C13.2061 0 14.7574 0.340939 16.2344 1.02282C17.7114 1.70472 19.0096 2.63818 20.1292 3.82321V0.179688H21.2376V5.63665H15.7869V4.53089H19.2646C18.2448 3.47488 17.0759 2.64003 15.7578 2.02634C14.4397 1.41262 13.0472 1.10576 11.5804 1.10576C8.67073 1.10576 6.198 2.10233 4.16219 4.09547C2.12635 6.08864 1.10842 8.52457 1.10842 11.4033C1.10842 14.3169 2.12357 16.7939 4.15386 18.834C6.18413 20.8742 8.65963 21.8942 11.5804 21.8942C14.3237 21.8942 16.6727 20.9645 18.6272 19.1049C20.5818 17.2454 21.6699 14.9657 21.8916 12.2658H23C22.8153 15.3066 21.6265 17.8559 19.4336 19.9135C17.2408 21.9712 14.623 23 11.5804 23ZM16.2801 16.9432L10.9818 11.7018V4.25996H12.0903V11.2457L17.081 16.1442L16.2801 16.9432Z",
    fill: "#2E5855"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.f25a284fea1de4dde6c066af737dc267.svg";
export { ForwardRef as ReactComponent };